import React, { useState } from "react"
import ChatRoom from "./ChatRoom";
import MessagesBox from "./MessagesBox";

const ChatContainer = ({open, onClose}) => {

    const [activeChat, setActiveChat] = useState(null)
    const [thumbnailImage, setThumbnailImage] = useState(null)
    const [chatroomLoading, setChatroomLoading] = useState(false)

    return (
        <div className="chat-page-container page-container">
            <div className="page-header hide-on-smlscreen">
                    <span className="header-text">Inbox</span>
            </div>
            <div className="messages-container">
                <MessagesBox setActiveChat={setActiveChat} activeChat={activeChat} thumbnailImage={thumbnailImage} setChatroomLoading={setChatroomLoading}/>
                <ChatRoom key={activeChat} setActiveChat={setActiveChat} chatroomId={activeChat} setThumbnailImage={setThumbnailImage} chatroomLoading={chatroomLoading} setChatroomLoading={setChatroomLoading}/>
            </div>
        </div>
    )
}

export default ChatContainer